module.exports = __webpack_public_path__ + "fonts/fa-regular-400.260be4f.ttf";